// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"3a661be8","977":"c9452d00"}[chunkId] + ".chunk.js";
};